import React from "react";
import "../../assets/css/about.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCards } from "swiper";
import { Hat2, Nft1, Nft2, Nft3, Tick } from "../../constant/Index";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Brands from "../Home/Brands";
import { useImageContentQuery } from "../../store/services/ImageService";
import { useSiteContentQuery } from "../../store/services/SitesettingService";
import { Link } from "react-router-dom";

const About = () => {
	const { data, isLoading } = useSiteContentQuery();
	let response = data?.response?.data[0];
	const { data: nftImage, isLoading: nftLoading } = useImageContentQuery();
	let NftImages = nftImage?.response?.data;
	return (
		<>
			{/* Header Start Here */}
			<Header />
			{/* Header End Here */}

			{/* About Start Here */}
			<section className="about_page">
				<div className="container">
					<div className="row align-items-center">
						<div className="col-lg-6">
							<div className="content-wrapper">
								<div className="glowing glowing-one">
									<span></span>
								</div>
								<div className="heading-wrapper">
									<h4>About</h4>
									<h2>{response?.about_title}</h2>
								</div>
								<div
									className="row"
									dangerouslySetInnerHTML={{
										__html: response?.about_description,
									}}
								></div>
								<div className="button-group mt-4 wow animate__animated animate__fadeInUp animate__delay-4s">
									<Link to="/community" className="buy-btn blue">
										<span className="txt">READ MORE</span>
										<span className="svg-icon">
											<svg width="28" height="28" viewBox="0 0 28 28">
												<defs>
													<filter
														id="Ellipse_15"
														x="0"
														y="0"
														width="28"
														height="28"
														filterUnits="userSpaceOnUse"
													>
														<feOffset dy="2" input="SourceAlpha" />
														<feGaussianBlur stdDeviation="1" result="blur" />
														<feFlood floodOpacity="0.302" />
														<feComposite operator="in" in2="blur" />
														<feComposite in="SourceGraphic" />
													</filter>
												</defs>
												<g
													id="Group_27"
													data-name="Group 27"
													transform="translate(-340 -668)"
												>
													<g
														transform="matrix(1, 0, 0, 1, 340, 668)"
														filter="url(#Ellipse_15)"
													>
														<circle
															id="Ellipse_15-2"
															data-name="Ellipse 15"
															cx="11"
															cy="11"
															r="11"
															transform="translate(3 1)"
															fill="#f9f928"
														/>
													</g>
													<path
														id="Path_16"
														data-name="Path 16"
														d="M585.823,402.516a.646.646,0,0,1-.556-.634c0-.054,0-.107,0-.161q0-3.333,0-6.665a1.178,1.178,0,0,1,.069-.419.626.626,0,0,1,.806-.343,2.325,2.325,0,0,1,.541.217q2.694,1.538,5.38,3.087a1.207,1.207,0,0,1,.509.48.736.736,0,0,1-.262.933,2.108,2.108,0,0,1-.255.17l-5.37,3.085a1.994,1.994,0,0,1-.669.249Z"
														transform="translate(-233.954 281.611)"
														fill="#d13900"
													/>
												</g>
											</svg>
										</span>
									</Link>
								</div>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="left-box">
								<div className="glowing glowing-one">
									<span></span>
								</div>
								<div className="glowing glowing-two">
									<span></span>
								</div>
								<div className="glowing glowing-three">
									<span></span>
								</div>
								<Swiper
									className="nft-slider swiper mySwiper"
									effect={"cards"}
									grabCursor={true}
									modules={[EffectCards]}
								>
									<div className="swiper-wrapper">
										{NftImages?.map((data, index) => {
											return (
												<SwiperSlide className="swiper-slide" key={data?.id}>
													<figure>
														<img
															src={data?.image_path}
															alt=""
															className="img-fluid"
														/>
													</figure>
												</SwiperSlide>
											);
										})}
									</div>
								</Swiper>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* About End Here */}

			{/* <!-- Benefits Sec Start Here --> */}
			<section className="benefits_sec about-benefit">
				<div className="hat-circle">
					<figure>
						<img src={Hat2} alt="nft-hat" className="img-fluid" />
					</figure>
				</div>
				<div className="container">
					<div className="benefit_box">
						<div className="row">
							<div className="col-lg-5"></div>
							<div className="col-lg-7">
								<div className="content-wrapper">
									<div className="heading-wrapper">
										<h4>BENEFITS</h4>
										<h2>YOUR NFT AT WORK –SIMPLE, EASY, FAST</h2>
									</div>
									<p>
										We offer the following premium benefit for Lend Me Token
										(LMT) collectors:
									</p>
									<ul className="points">
										<li>
											<img src={Tick} alt="" className="img-fluid" /> Mortgage
											Deals
										</li>
										<li>
											<img src={Tick} alt="" className="img-fluid" /> Students
											Loans
										</li>
										<li>
											<img src={Tick} alt="" className="img-fluid" /> Loans
											Against Nft as Collateral
										</li>
										<li>
											<img src={Tick} alt="" className="img-fluid" /> Exclusive
											Deals from Lend Me Money for LMT Buyers{" "}
										</li>
										{/* <li>
											<img src={Tick} alt="" className="img-fluid" /> Students
											Loans
										</li> */}
										<li>
											<img src={Tick} alt="" className="img-fluid" /> Access to
											partner communities & their utilities
										</li>
										<li>
											<img src={Tick} alt="" className="img-fluid" /> SMEs
											Enterprise Support
										</li>
										<li>
											<img src={Tick} alt="" className="img-fluid" /> Credit
											Card Subscriptions
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* <!-- Benefits Sec End Here --> */}

			{/* <!-- Brands Sec Start Here --> */}
			<section className="brand_sec brands-for-about">
				<div className="container">
					<div className="heading-wrapper">
						<div className="glowing glowing-one">
							<span></span>
						</div>
						<h4>Powered By Lend Me Money</h4>
						{/* <h4>Powered By Lend Me Money</h4> */}
						<h2>Our Investors</h2>
						<h3>We Are Supported by the Best</h3>
						<p>
							Our global investors and supporters include the leading funds &
							financial institutions.
						</p>
					</div>
					<Brands />
				</div>
			</section>
			{/* <!-- Brands Sec End Here --> */}

			{/* Footer Start Here */}
			<Footer />
			{/* Footer End Here */}
		</>
	);
};

export default About;
